const CardWithLoader = require("../Dashboard/card-with-loader");
const Chart = require("../Dashboard/Chart/chart");

const Reflux = require("reflux");
const FinishedActivitiesStore = require("../../stores/finished-activities-store");
const FinishedActivitiesActions = require("../../actions/finished-activities-actions");

const ChartDataLabels = require("chartjs-plugin-datalabels");

const FinishedActivitiesWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  activityTypes: {
    visit: {
      label: "Visita",
      color: "#b63233"
    },
    call: {
      label: "Ligação",
      color: "#3126E6"
    },
    whatsapp: {
      label: "WhatsApp",
      color: "#1cc559"
    },
    email: {
      label: "E-mail",
      color: "#57a4dd"
    },
    meeting: {
      label: "Reunião",
      color: "#dc9d74"
    },
    proposal: {
      label: "Proposta",
      color: "#dba118"
    },
    no_type: {
      label: "Sem tipo",
      color: "#646270"
    }
  },

  getInitialState: function () {
    return FinishedActivitiesStore.getInitialState();
  },

  componentDidMount: function () {
    this.listenTo(FinishedActivitiesStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function (prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function () {
    FinishedActivitiesActions.fetchData(
      this.props.period,
      this.props.users
    );
  },

  chartData: function () {
    let labels = [];
    let datasets = {};

    let length = this.state.data.finishedActivities.length;
    let buildInitialDataset = (name, id) => {
      let { label, color } = this.activityTypes[name];

      return ({
        label: label,
        data: new Array(length).fill(0),
        backgroundColor: color,
        borderColor: color,
        typeId: id,
        typeName: name,
      });
    };

    this.state.data.finishedActivities.forEach(({ user, types }, index) => {
      labels.push(user.name);

      types.forEach(({ name, count, id }) => {
        datasets[name] = datasets[name] || buildInitialDataset(name, id);
        datasets[name].data[index] = count;
      });
    });

    datasets = Object.values(datasets);

    return { labels, datasets };
  },

  getDetailsUrl: function (userId, typeId, typeName) {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    searchParams.append("pending", false);
    searchParams.append("dateRange", "CUSTOM");
    searchParams.append("dtInicial", formattedStartDate);
    searchParams.append("dtFinal", formattedEndDate);
    searchParams.append("userId", userId);
    searchParams.append("typeName", typeName);

    // Added metrics_ids manually because otherwise the brackets were escaped
    // and the filtering did not work.
    return `/sistema/tarefas?${searchParams}&metric_ids=[${typeId}]`;
  },

  scrollContainerHeight: 500,

  render: function () {
    let { labels, datasets } = this.chartData();
    let chartHeight = Math.max(
      this.scrollContainerHeight,
      20 * (labels.length * datasets.length + 1)
    );

    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Quem <strong>finalizou</strong> mais tarefas?</p>
        }
        className="grid-item-col-4"
      >
        <div className="ovy-auto thinScrollbar" style={{ height: this.scrollContainerHeight }}>
          <Chart
            type="horizontalBar"
            style={{ height: chartHeight }}
            datasets={datasets}
            labels={labels}
            plugins={[ChartDataLabels]}
            options={{
              maintainAspectRatio: false,
              scales: {
                xAxes: [{
                  position: "top",
                  gridLines: {
                    drawTicks: false
                  }
                },
                {
                  position: "bottom",
                  gridLines: {
                    display: false,
                    drawTicks: false
                  },
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  barPercentage: 0.8,
                  minBarLength: 5,
                  gridLines: {
                    drawTicks: false
                  }
                }]
              },
              tooltips: {
                displayColors: true,
                mode: "index"
              },
              plugins: {
                datalabels: {
                  formatter: value => value == 0 ? "" : value.toString(),
                  anchor: "end",
                  align: "end"
                }
              },
              hover: {
                intersect: true,
                mode: "nearest"
              },
              onHover: (event, elements) => {
                if (elements.length > 0) {
                  event.target.style.setProperty("cursor", "pointer");
                } else {
                  event.target.style.removeProperty("cursor");
                }
              },
              onClick: (_, [element]) => {
                if (element) {
                  let item = this.state.data.finishedActivities[element._index];
                  let typeId = datasets[element._datasetIndex].typeId;
                  let typeName = datasets[element._datasetIndex].typeName;

                  window.open(this.getDetailsUrl(item.user.id, typeId, typeName), "_blank");
                }
              }
            }}
          />
        </div>
      </CardWithLoader>
    )
  }
});

module.exports = FinishedActivitiesWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/finished-activities-widget.jsx